"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WarWolfsSwipeAbilityHandler = exports.WarWolfsSwipeActorAbilityFactory = exports.WarWolfsSwipeAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Duration_1 = require("../../core/Duration");
const Vulnerability_1 = require("../../core/effects/core/Vulnerability");
const Random_1 = require("../../utils/Random");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class WarWolfsSwipeAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.WarWolfsSwipe;
        this.__typeName = "WarWolfsSwipe";
    }
}
exports.WarWolfsSwipeAbilityArgs = WarWolfsSwipeAbilityArgs;
let WarWolfsSwipeActorAbilityFactory = class WarWolfsSwipeActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("WarWolfsSwipe", "OneEnemies", 0);
    }
};
WarWolfsSwipeActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("WarWolfsSwipe")
], WarWolfsSwipeActorAbilityFactory);
exports.WarWolfsSwipeActorAbilityFactory = WarWolfsSwipeActorAbilityFactory;
let WarWolfsSwipeAbilityHandler = class WarWolfsSwipeAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [targetId] = ability.args.target.actorIds;
        container.applyMultiAttack({
            sequence,
            abilityKey: "WarWolfsSwipe",
            attackType: "melee",
            attackerId: ability.invokerId,
            targets: [{
                    damages: [
                        AbilityDamage_1.AbilityDamage.Power("Physical", 108)
                    ],
                    targetId,
                    effects: [
                        {
                            targetId,
                            duration: Duration_1.Duration.Turns(2),
                            effect: new Vulnerability_1.VulnerabilityEffectArgs((0, Random_1.random)(1, 3))
                        }
                    ]
                }]
        });
    }
};
WarWolfsSwipeAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.WarWolfsSwipe)
], WarWolfsSwipeAbilityHandler);
exports.WarWolfsSwipeAbilityHandler = WarWolfsSwipeAbilityHandler;
